<div class="calendar-controls flex flex-row justify-between items-end">
  <div class="calendar-controls__first-column flex flex-row">
    <!-- location controls section -->
    @if (locations && locations?.length === 1 && transferEvent) {
      <div class="calendar-controls__location">
        <ss-heading
          heading="5"
          [underline]="false"
          [label]="locations[0].name"
        ></ss-heading>
      </div>
    }
    @if (!transferEvent && locations && locations?.length === 2) {
      <div class="calendar-controls__location">
        <ss-heading
          heading="5"
          [underline]="false"
          label="SHOW LOCATION:"
        ></ss-heading>
        @if (locationOptions()) {
          <ss-tabs
            name="locations"
            data-test="location-toggle"
            [tabs]="locationOptions()!"
            [toggleMode]="true"
            (changed)="handleLocationChange($any($event))"
          ></ss-tabs>
        }
      </div>
    }

    <!-- year controls section -->
    @if (years && years.length >= 2 && !transferEvent && yearsTabOptions) {
      <div class="calendar-controls__year">
        <ss-heading heading="5" [underline]="false" label="YEAR:"></ss-heading>
        <ss-tabs
          name="years"
          data-test="year-toggle"
          [tabs]="yearsTabOptions"
          [toggleMode]="true"
          (changed)="handleYearChange($any($event))"
        ></ss-tabs>
      </div>
    }

    @if (transferEvent && locations) {
      <div class="calendar-controls__location">
        <ss-heading
          heading="5"
          [underline]="false"
          [label]="eventYear"
        ></ss-heading>
      </div>
    }

    <!-- event type toggle section -->
    @if (eventTypes && eventTypes.length > 2) {
      <div class="calendar-controls__event-type">
        <ss-heading
          heading="5"
          [underline]="false"
          label="EVENT TYPE:"
        ></ss-heading>
        <ss-tabs
          [tabs]="eventTypes"
          (changed)="handleEvenTypeChange($any($event))"
        >
        </ss-tabs>
      </div>
    }
  </div>

  <!-- emp comp type toggle section -->
  @if (empCompTypes && empCompTypes.length) {
    <div class="calendar-controls__event-type w-72">
      <ss-heading
        heading="5"
        [underline]="false"
        label="EMPLOYEE COMP TYPE:"
      ></ss-heading>
      <ss-ui-select
        [data]="empCompTypes"
        (valueChange)="handleCompTypeChange($event)"
      >
        <ss-ui-select-trigger ssInput formControlName="align"
          >Filter by comp type</ss-ui-select-trigger
        >
      </ss-ui-select>
    </div>
  }

  <!-- event type controls section -->
  <div class="calendar-controls__event-type flex flex-row gap-x-2.5">
    @for (event of events; track event) {
      <ss-chip
        [text]="event.name"
        [color]="event.displayColor"
        data-test="event-name-calendar-control"
      >
      </ss-chip>
    }
    @if (!events?.length) {
      <div data-test="event-name-calendar-control"></div>
    }
  </div>
</div>
